import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../store';


@customElement('model-overview')
export class ModelOverview extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				width: 100%;
				margin: 0;
				font: var(--font-specsheet-small-text);
			}

			.imagesContainer {
				margin-top: 1cqw;
				margin-bottom: 3cqw;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				grid-template-rows: 1fr;
				grid-column-gap: 1cqw;
				grid-row-gap: 0;

			}

			.img {
				width: 100%;
				height: auto;
				object-fit: cover;
			}
		`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		if (state.specsheet.data.specsheets && state.status?.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
			this.usps = this.kirbySpecsheet?.usps;
		}
	}

	render() {
		if (!this.kirbySpecsheet) return html``;

		return html`
			<div class="modelOverview">
				<div class="imagesContainer">
					${when(this.kirbySpecsheet.model_image_1, () => html`
						<img class="img" src=${this.kirbySpecsheet.model_image_1}/>
					`, () => html``)}
					${when(this.kirbySpecsheet.model_image_2, () => html`
						<img class="img" src=${this.kirbySpecsheet.model_image_2}/>
					`, () =>  html``)}
					${when(this.kirbySpecsheet.model_image_3, () => html`
						<img class="img" src=${this.kirbySpecsheet.model_image_3}/>
					`, () => html``)}
				</div>

				${this.usps.map((usp) => html`
					<usp-table title="${usp.usp_title}">
						${usp.usp.map((item, index) => html`
							<usp-table-item>
								<div slot="label">${item.usp_title}</div>
								<div slot="value">${item.usp_description}</div>
							</usp-table-item>
						`)}
					</usp-table>
				`)}
			</div>
		`;
	}
}
